import React from 'react';
import { LogoFull } from '../components/Images';

const WelcomeScreen = () => {
  return (
    <div className="w-full flex">
      <div className="w-full flex justify-center items-center">
        <img src={LogoFull} alt="" className='mt-10 mb-10 max-w-52'/>
      </div>
    </div>
  );
};

export default WelcomeScreen;